import type { Order } from "./types-order";
import type { CallFlowType } from "./types-interfaces";


// Only columns that are filtered client-side (no matching API param).
// date, city, window are filtered server-side via API params.
export const workflowFilterColumns = [
  { key: "whiteGlove", label: "White Glove", accessor: (o: Order) => (o.white_glove_service ? "Yes" : "No") },
  { key: "outcome", label: "Outcome", accessor: (o: Order) => o.last_outcome ?? "" },
];

export const isDev = import.meta.env.DEV || import.meta.env.VITE_ENV === "dev";

export const CALL_FLOW = {
  FLOW_1: 'Canada',
  FLOW_2: 'Intl',
  FLOW_3: 'Canada-Voice',
} as const;

export type CallFlowDisplayName = (typeof CALL_FLOW)[keyof typeof CALL_FLOW];

export const CALL_FLOW_OPTIONS: CallFlowDisplayName[] = isDev
  ? [CALL_FLOW.FLOW_1, CALL_FLOW.FLOW_2, CALL_FLOW.FLOW_3]
  : [CALL_FLOW.FLOW_1, CALL_FLOW.FLOW_2];

/** Maps UI flow selection to API callFlowType */
export const CALL_FLOW_TO_API_TYPE: Record<CallFlowDisplayName, CallFlowType> = {
  [CALL_FLOW.FLOW_1]: 'dtmf',
  [CALL_FLOW.FLOW_2]: 'dtmf-intl',
  [CALL_FLOW.FLOW_3]: 'lex',
};

export const Outcome = {
  Answered: 'answered',
  Rescheduled: 'rescheduled',
  AlternateWindow: 'alternate_window',
  ConfirmedWithVoicemail: 'confirmed_with_voicemail',
  ConfirmedWithNoAnswer: 'confirmed_with_no_answer',
  ConfirmedThroughTransfer: 'confirmed_through_transfer',
  IncorrectPhoneNumber: 'incorrect_phone_number',
  Cancelled: 'cancelled'
} as const;

export const liveTransferOutcomeOptions = [
  { value: "confirmed", label: "CALL Confirmed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "reschedule", label: "Rescheduled" },
  { value: "no_answer", label: "No Answer" },
] as const;

export const defaultOutcomeOptions = [
  { value: "confirmed", label: "Confirmed" },
  { value: "alt_window", label: "Alternate Window" },
  { value: "reschedule", label: "Reschedule" },
  { value: "no_answer", label: "No Answer" },
  { value: "invalid_number", label: "Invalid Number" },
] as const;
